export const clientRTTI = Symbol.for("Client");
export const clientProviderRTTI = Symbol.for("ClientProvider");
export const clientOptionsRTTI = Symbol.for("ClientOptions");
export const clientMockOptionsRTTI = Symbol.for("ClientMockOptions");
